import ErrorLoadDataImg from "@/core/assets/error_load.png";
import { Alert, AlertDescription, AlertTitle } from "@/core/components/ui/alert";
import { Button } from "@/core/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/core/components/ui/card";
import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { AlertCircle, RefreshCcw } from "lucide-react";

export const LoadScreenError = () => {
  const { t } = useTypedTranslation();

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-full items-center justify-center bg-muted">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-center text-2xl font-bold text-destructive">
            {t("LabelError")}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex justify-center">
            <img
              src={ErrorLoadDataImg}
              alt={t("loadErrorImageAlt")}
              className="h-48 w-48 object-cover"
            />
          </div>
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>{t("errorPageTitle")}</AlertTitle>
            <AlertDescription>{t("loadErrorDescription")}</AlertDescription>
          </Alert>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button onClick={handleRefresh} className="w-full">
            <RefreshCcw className="mr-2 h-4 w-4" />
            {t("refreshPage")}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};
